"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notEmpty = notEmpty;
exports.parseFileIgnores = parseFileIgnores;
exports.getGlobPatterns = getGlobPatterns;
exports.collectFilePolicies = collectFilePolicies;
exports.determineBaseDir = determineBaseDir;
exports.collectBundleFiles = collectBundleFiles;
exports.prepareExtendingBundle = prepareExtendingBundle;
exports.getBundleFilePath = getBundleFilePath;
exports.calcHash = calcHash;
exports.getFileInfo = getFileInfo;
exports.resolveBundleFiles = resolveBundleFiles;
exports.resolveBundleFilePath = resolveBundleFilePath;
exports.composeFilePayloads = composeFilePayloads;
exports.isMatch = isMatch;
const nodePath = __importStar(require("path"));
const fs = __importStar(require("fs"));
const fast_glob_1 = __importDefault(require("fast-glob"));
const minimatch_1 = require("minimatch");
const crypto_1 = __importDefault(require("crypto"));
const yaml_1 = require("yaml");
const lodash_union_1 = __importDefault(require("lodash.union"));
const util_1 = __importDefault(require("util"));
const cache_1 = require("./cache");
const constants_1 = require("./constants");
const isWindows = nodePath.sep === '\\';
const asyncLStat = util_1.default.promisify(fs.lstat);
const lStat = async (path) => {
    let fileStats = null;
    try {
        // eslint-disable-next-line no-await-in-loop
        fileStats = await asyncLStat(path);
    }
    catch (err) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (err.code === 'EACCES' || err.code === 'EPERM') {
            console.log(`${path} is not accessible. Please check permissions and adjust .dcignore file to not even test this file`);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (err.code === 'ENOENT') {
            console.log(`no such file or directory: ${path}`);
        }
    }
    return fileStats;
};
function notEmpty(value) {
    return value !== null && value !== undefined;
}
const matchOptions = { matchBase: true, dot: true };
const fgOptions = {
    dot: true,
    absolute: true,
    baseNameMatch: true,
    onlyFiles: true,
    suppressErrors: true,
};
function filterSupportedFiles(files, supportedFiles) {
    const patterns = getGlobPatterns(supportedFiles);
    return files.filter(f => patterns.some(p => (0, minimatch_1.minimatch)(f, p, matchOptions)));
}
function parseIgnoreRulesToGlobs(rules, baseDir) {
    // Mappings from .gitignore format to glob format:
    // `/foo/` => `/foo/**` (meaning: Ignore root (not sub) foo dir and its paths underneath.)
    // `/foo`	=> `/foo/**`, `/foo` (meaning: Ignore root (not sub) file and dir and its paths underneath.)
    // `foo/` => `**/foo/**` (meaning: Ignore (root/sub) foo dirs and their paths underneath.)
    // `foo` => `**/foo/**`, `foo` (meaning: Ignore (root/sub) foo files and dirs and their paths underneath.)
    return rules.reduce((results, rule) => {
        let prefix = '';
        if (rule.startsWith('!')) {
            // eslint-disable-next-line no-param-reassign
            rule = rule.substring(1);
            prefix = '!';
        }
        const startingSlash = rule.startsWith('/');
        const startingGlobstar = rule.startsWith('**');
        const endingSlash = rule.endsWith('/');
        const endingGlobstar = rule.endsWith('**');
        if (startingSlash || startingGlobstar) {
            // case `/foo/`, `/foo` => `{baseDir}/foo/**`
            // case `**/foo/`, `**/foo` => `{baseDir}/**/foo/**`
            if (!endingGlobstar)
                results.push(prefix + nodePath.posix.join(baseDir, rule, '**'));
            // case `/foo` => `{baseDir}/foo`
            // case `**/foo` => `{baseDir}/**/foo`
            // case `/foo/**` => `{baseDir}/foo/**`
            // case `**/foo/**` => `{baseDir}/**/foo/**`
            if (!endingSlash)
                results.push(prefix + nodePath.posix.join(baseDir, rule));
        }
        else {
            // case `foo/`, `foo` => `{baseDir}/**/foo/**`
            if (!endingGlobstar)
                results.push(prefix + nodePath.posix.join(baseDir, '**', rule, '**'));
            // case `foo` => `{baseDir}/**/foo`
            // case `foo/**` => `{baseDir}/**/foo/**`
            if (!endingSlash)
                results.push(prefix + nodePath.posix.join(baseDir, '**', rule));
        }
        return results;
    }, []);
}
function parseFileIgnores(path) {
    let rules = [];
    const dirname = nodePath.dirname(path);
    try {
        const f = fs.readFileSync(path, { encoding: 'utf8' });
        if (path.includes(constants_1.DOTSNYK_FILENAME)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const parsed = (0, yaml_1.parse)(f);
            const codeIgnoredPaths = parsed.exclude.code || [];
            const globalIgnoredPaths = parsed.exclude.global || [];
            rules = [...codeIgnoredPaths, ...globalIgnoredPaths];
        }
        else {
            rules = f
                .split('\n')
                .map(l => l.trim())
                .filter(l => !!l && !l.startsWith('#'));
        }
    }
    catch (err) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (err.code === 'EACCES' || err.code === 'EPERM') {
            console.log(`${path} is not accessible. Please check permissions and adjust .dcignore file to not even test this file`);
        }
    }
    try {
        return parseIgnoreRulesToGlobs(rules, dirname);
    }
    catch (err) {
        console.error('Could not parse ignore rules to glob', { path });
        throw new Error('Please make sure ignore file follows correct syntax');
    }
}
function getGlobPatterns(supportedFiles) {
    return [
        ...supportedFiles.extensions.map(e => `${generateAllCaseGlobPattern(e)}`),
        ...supportedFiles.configFiles.filter(e => !constants_1.EXCLUDED_NAMES.includes(e)),
    ];
}
// Generates glob patterns for case-insensitive file extension matching.
// E.g. *.[jJ][sS] for matching .js files without case-sensitivity.
function generateAllCaseGlobPattern(fileExtension) {
    const chars = Array.from(fileExtension);
    if (!chars.length) {
        console.log('Invalid file extension pattern: file extension is empty.');
        return '';
    }
    if (chars[0] != '.') {
        console.log("Invalid file extension pattern: missing '.' in the beginning of the file extension. Some files may not be included in the analysis.");
        return '';
    }
    const caseInsensitivePatterns = chars.reduce((pattern, extensionChar, i) => {
        if (i == 0) {
            // first char should always be '.', no need to generate multiple cases for file extension character
            return ['*.'];
        }
        if (extensionChar.toLowerCase() == extensionChar.toUpperCase()) {
            // Char doesn't have case variant, return as-is.
            return pattern.concat(extensionChar);
        }
        const globCharPattern = `[${extensionChar.toLowerCase()}${extensionChar.toUpperCase()}]`;
        return pattern.concat(globCharPattern);
    }, []);
    return caseInsensitivePatterns.join('');
}
/**
 * Recursively collect all exclude and ignore rules from "dirs".
 *
 * Exclude rules from .snyk files and ignore rules from .[*]ignore files are collected separately.
 * Any .[*]ignore files in paths excluded by .snyk exclude rules are ignored.
 */
async function collectFilePolicies(dirs, symlinksEnabled = false, fileIgnores = constants_1.IGNORES_DEFAULT) {
    const tasks = dirs.map(async (folder) => {
        const fileStats = await lStat(folder);
        // Check if symlink and exclude if requested
        if (!fileStats || (fileStats.isSymbolicLink() && !symlinksEnabled) || fileStats.isFile()) {
            return {
                excludes: [],
                ignores: [],
            };
        }
        // Find .snyk and .[*]ignore files inside this directory.
        const allIgnoredFiles = await (0, fast_glob_1.default)(constants_1.IGNORE_FILES_NAMES.map(i => `*${i}`), {
            ...fgOptions,
            cwd: folder,
            followSymbolicLinks: symlinksEnabled,
        });
        // Parse rules from all .snyk files inside this directory.
        const snykFiles = allIgnoredFiles.filter(f => f.endsWith(constants_1.DOTSNYK_FILENAME));
        const snykExcludeRules = (0, lodash_union_1.default)(...snykFiles.map(parseFileIgnores));
        // Parse rules from relevant .[*]ignore files inside this directory.
        // Exclude ignore files under paths excluded by .snyk files.
        const ignoreFiles = allIgnoredFiles.filter(f => !f.endsWith(constants_1.DOTSNYK_FILENAME) && !snykExcludeRules.some(rule => (0, minimatch_1.minimatch)(nodePath.dirname(f), rule)));
        const ignoreFileRules = (0, lodash_union_1.default)(...ignoreFiles.map(parseFileIgnores));
        return {
            excludes: snykExcludeRules,
            ignores: ignoreFileRules,
        };
    });
    const collectedRules = await Promise.all(tasks);
    return {
        excludes: (0, lodash_union_1.default)(...collectedRules.map(policies => policies.excludes)),
        // Merge external and collected ignore rules
        ignores: (0, lodash_union_1.default)(fileIgnores, ...collectedRules.map(policies => policies.ignores)),
    };
}
function determineBaseDir(paths) {
    if (paths.length === 1) {
        const path = paths[0];
        const stats = fs.lstatSync(path);
        if (stats.isFile()) {
            return nodePath.dirname(path);
        }
        return path;
    }
    return '';
}
async function* searchFiles(patterns, cwd, symlinksEnabled, policies) {
    const positiveIgnores = [...policies.excludes, ...policies.ignores.filter(rule => !rule.startsWith('!'))];
    const negativeIgnores = policies.ignores.filter(rule => rule.startsWith('!')).map(rule => rule.substring(1));
    // We need to use the ignore rules directly in the stream. Otherwise we would expand all the branches of the file system
    // that should be ignored, leading to performance issues (the parser would look stuck while analyzing each ignored file).
    // However, fast-glob doesn't address the negative rules in the ignore option correctly.
    // As a compromise between correctness and performance, we split the search in two streams, the first one using the
    // extension patterns as a search term and the positive ignore rules in the options, while the second that manually
    // expands those branches that should be excluded from the ignore rules throught the negative ignores as search term
    // and then matches the extensions as a second step to exclude any file that should not be analyzed.
    const positiveSearcher = fast_glob_1.default.stream(patterns, {
        ...fgOptions,
        cwd,
        followSymbolicLinks: symlinksEnabled,
        ignore: positiveIgnores,
    });
    for await (const filePath of positiveSearcher) {
        yield filePath;
    }
    const deepPatterns = patterns.map(p => `**/${p}`);
    // TODO: This is incorrect because the .gitignore format allows to specify exceptions to previous rules, therefore
    // the separation between positive and negative ignores is incorrect in a scenario with 2+ exeptions like the one below:
    // `node_module/` <= ignores everything in a `node_module` folder and it's relative subfolders
    // `!node_module/my_module/` <= excludes the `my_module` subfolder from the ignore
    // `node_module/my_module/build/` <= re-includes the `build` subfolder in the ignore
    if (negativeIgnores.length) {
        const negativeSearcher = fast_glob_1.default.stream(negativeIgnores, {
            ...fgOptions,
            cwd,
            followSymbolicLinks: symlinksEnabled,
            baseNameMatch: false,
            // Exclude rules should still be respected
            ignore: policies.excludes,
        });
        for await (const filePath of negativeSearcher) {
            if (isMatch(filePath.toString(), deepPatterns))
                yield filePath;
        }
    }
}
/**
 * Returns bundle files from requested paths
 * If a file exceeds the maximum file size, it returns a string with its path
 * */
async function* collectBundleFiles({ symlinksEnabled = false, baseDir, filePolicies, paths, supportedFiles, }) {
    const cache = new cache_1.Cache(constants_1.CACHE_KEY, baseDir);
    const files = [];
    const dirs = [];
    // Split into directories and files and exclude symlinks if needed
    for (const path of paths) {
        // eslint-disable-next-line no-await-in-loop
        const fileStats = await lStat(path);
        // Check if symlink and exclude if requested
        if (!fileStats || (fileStats.isSymbolicLink() && !symlinksEnabled))
            continue;
        if (fileStats.isFile()) {
            fileStats.size <= constants_1.MAX_FILE_SIZE ? files.push(path) : yield path;
        }
        else if (fileStats.isDirectory()) {
            dirs.push(path);
        }
    }
    // Scan folders
    const globPatterns = getGlobPatterns(supportedFiles);
    for (const folder of dirs) {
        const searcher = searchFiles(globPatterns, folder, symlinksEnabled, filePolicies);
        // eslint-disable-next-line no-await-in-loop
        for await (const filePath of searcher) {
            const fileInfo = await getFileInfo(filePath.toString(), baseDir, false, cache);
            // dc ignore AttrAccessOnNull: false positive, there is a precondition with &&
            if (fileInfo) {
                fileInfo.size <= constants_1.MAX_FILE_SIZE ? yield fileInfo : yield fileInfo.bundlePath;
            }
        }
    }
    // Sanitize files
    if (files.length) {
        const searcher = searchFiles(filterSupportedFiles(files, supportedFiles), baseDir, symlinksEnabled, filePolicies);
        for await (const filePath of searcher) {
            const fileInfo = await getFileInfo(filePath.toString(), baseDir, false, cache);
            // dc ignore AttrAccessOnNull: false positive, there is a precondition with &&
            if (fileInfo) {
                fileInfo.size <= constants_1.MAX_FILE_SIZE ? yield fileInfo : yield fileInfo.bundlePath;
            }
        }
    }
    cache.save();
}
async function prepareExtendingBundle(baseDir, supportedFiles, fileIgnores = constants_1.IGNORES_DEFAULT, files, symlinksEnabled = false) {
    let removedFiles = [];
    let bundleFiles = [];
    const cache = new cache_1.Cache(constants_1.CACHE_KEY, baseDir);
    // Filter for supported extensions/files only
    let processingFiles = filterSupportedFiles(files, supportedFiles);
    // Exclude files to be ignored based on ignore rules. We assume here, that ignore rules have not been changed.
    processingFiles = processingFiles.map(f => resolveBundleFilePath(baseDir, f)).filter(f => !isMatch(f, fileIgnores));
    if (processingFiles.length) {
        // Determine existing files (minus removed)
        if (isWindows) {
            processingFiles = processingFiles.map(f => f.replace(/\\/g, '/')); // fg requires forward-slashes in Windows globs
        }
        const entries = await (0, fast_glob_1.default)(processingFiles, {
            ...fgOptions,
            cwd: baseDir,
            followSymbolicLinks: symlinksEnabled,
            objectMode: true,
            stats: true,
        });
        let foundFiles = new Set(); // This initialization is needed to help Typescript checker
        foundFiles = entries.reduce((s, e) => {
            if (e.stats && e.stats.size <= constants_1.MAX_FILE_SIZE) {
                s.add(e.path);
            }
            return s;
        }, foundFiles);
        removedFiles = processingFiles.reduce((s, p) => {
            if (!foundFiles.has(p)) {
                s.push(getBundleFilePath(p, baseDir));
            }
            return s;
        }, []);
        if (foundFiles.size) {
            bundleFiles = (await Promise.all([...foundFiles].map((p) => getFileInfo(p, baseDir, false, cache)))).filter(notEmpty);
        }
    }
    return {
        files: bundleFiles,
        removedFiles,
    };
}
function getBundleFilePath(filePath, baseDir) {
    const relPath = baseDir ? nodePath.relative(baseDir, filePath) : filePath; // relPath without explicit base makes no sense
    const posixPath = !isWindows ? relPath : relPath.replace(/\\/g, '/');
    return encodeURI(posixPath);
}
function calcHash(content) {
    return crypto_1.default.createHash(constants_1.HASH_ALGORITHM).update(content).digest(constants_1.ENCODE_TYPE);
}
async function getFileInfo(filePath, baseDir, withContent = false, cache = null) {
    const fileStats = await lStat(filePath);
    if (fileStats === null) {
        return fileStats;
    }
    const bundlePath = getBundleFilePath(filePath, baseDir);
    let fileContent = '';
    let fileHash = '';
    if (!withContent && !!cache) {
        // Try to get hash from cache
        const cachedData = cache.getKey(filePath);
        if (cachedData) {
            if (cachedData[0] === fileStats.size && cachedData[1] === fileStats.mtimeMs) {
                fileHash = cachedData[2];
            }
            else {
                // console.log(`did not match cache for: ${filePath} | ${cachedData} !== ${[fileStats.size, fileStats.mtime]}`);
            }
        }
    }
    if (!fileHash) {
        try {
            fileContent = fs.readFileSync(filePath, { encoding: 'utf8' });
            fileHash = calcHash(fileContent);
            cache === null || cache === void 0 ? void 0 : cache.setKey(filePath, [fileStats.size, fileStats.mtimeMs, fileHash]);
        }
        catch (err) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (err.code === 'EACCES' || err.code === 'EPERM') {
                console.log(`${filePath} is not accessible. Please check permissions and adjust .dcignore file to not even test this file`);
            }
        }
    }
    return {
        filePath,
        bundlePath,
        size: fileStats.size,
        hash: fileHash,
        content: withContent ? fileContent : undefined,
    };
}
async function resolveBundleFiles(baseDir, bundleMissingFiles) {
    const cache = new cache_1.Cache('.dccache', baseDir);
    const tasks = bundleMissingFiles.map(mf => {
        const filePath = resolveBundleFilePath(baseDir, mf);
        return getFileInfo(filePath, baseDir, true, cache);
    });
    const res = (await Promise.all(tasks)).filter(notEmpty);
    cache.save(true);
    return res;
}
function resolveBundleFilePath(baseDir, bundleFilePath) {
    let relPath = bundleFilePath;
    if (isWindows) {
        relPath = relPath.replace(/\//g, '\\');
    }
    if (baseDir) {
        return nodePath.resolve(baseDir, decodeURI(relPath));
    }
    return decodeURI(relPath);
}
// MAX_PAYLOAD / 2 is because every char takes 2 bytes in the payload
function* composeFilePayloads(files, bucketSize = constants_1.MAX_PAYLOAD / 2) {
    const buckets = [{ size: bucketSize, files: [] }];
    let bucketIndex = -1;
    const getFileDataPayloadSize = (fileData) => {
        var _a;
        return (((_a = fileData.content) === null || _a === void 0 ? void 0 : _a.length) ? fileData.content.length + 16 : 0) +
            fileData.bundlePath.length +
            fileData.hash.length +
            6;
    }; // constants is for the separators
    const isLowerSize = (size, fileData) => size >= getFileDataPayloadSize(fileData);
    for (const fileData of files) {
        // This file is empty or too large to send, it should be skipped.
        if (!fileData.size || !isLowerSize(bucketSize, fileData))
            continue;
        // Find suitable bucket
        bucketIndex = buckets.findIndex(b => isLowerSize(b.size, fileData));
        if (bucketIndex === -1) {
            // Create a new bucket
            buckets.push({ size: bucketSize, files: [] });
            bucketIndex = buckets.length - 1;
        }
        buckets[bucketIndex].files.push(fileData);
        buckets[bucketIndex].size -= getFileDataPayloadSize(fileData);
        if (buckets[bucketIndex].size < bucketSize * 0.01) {
            yield buckets[bucketIndex].files; // Give bucket to requester
            buckets.splice(bucketIndex); // Remove it as fullfilled
        }
    }
    // Send all left-over buckets
    for (const bucket of buckets.filter(b => b.files.length)) {
        yield bucket.files;
    }
}
function isMatch(filePath, rules) {
    const opts = { ...matchOptions, matchBase: false };
    const positiveRules = rules.filter(r => !r.startsWith('!'));
    const negativeRules = rules.filter(r => r.startsWith('!')).map(r => r.slice(1));
    const matched = positiveRules.some(rule => (0, minimatch_1.minimatch)(filePath, rule, opts));
    if (!matched)
        return false;
    return !negativeRules.some(rule => (0, minimatch_1.minimatch)(filePath, rule, opts));
}
//# sourceMappingURL=files.js.map